import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router'
import { environment } from 'src/environments/environment'
let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'GPI-ACES-Client';
  constructor(private router: Router) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.gtag;
    document.head.prepend(script);
  }
  ngOnInit(): void {
    this.googleAnalytics();
  }

  googleAnalytics() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.gtag('config', environment.gtag, { 'page_path': event.urlAfterRedirects });
      }
    })
  }
}
